import script from "./UaqiDiagram.vue?vue&type=script&setup=true&lang=js"
export * from "./UaqiDiagram.vue?vue&type=script&setup=true&lang=js"

import "./UaqiDiagram.vue?vue&type=style&index=0&id=499a8069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-499a8069"]])

export default __exports__